<template>
<v-card height="calc(100vh - 336px)" flat>
    <v-card-title>
        <v-spacer></v-spacer>
        Xin vui lòng đợi get jti:.... {{redirectToURL}}
        <v-spacer></v-spacer>
        
    </v-card-title>
    <v-card-text class="text-center">
        <v-progress-circular class="my-12"
        :size="200"
        :width="7"
        color="orange"
        indeterminate
        ></v-progress-circular>
    </v-card-text>
</v-card>
</template>

<script>
import http from '@/components/services/http-common';
export default {
    props: ['id'],
    data(){
        return {
            redirected: false,
            redirectToURL: "muahang.trungsonpharma.com/account/login/internal?token=token"
        }
    },
    computed:{
        jwt() {
            let token = localStorage.getItem('token')
            return token
        },
        getJti() {
        let token = localStorage.getItem('token')
        if (!token) return null

        const payload = token.split('.')[1]
        if (!payload) return null

        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
        return decoded.jti || null
        }

    },
    methods:{
        redirectTo() {
            if(!this.redirected){
                let jti = this.getJti
                if(!jti) {
                    alert("not found jti")
                    return
                }
                    
                window.location.href = `https://muahang.trungsonpharma.com/account/login/internal?token=${jti}`;
                // alert(`https://muahang.trungsonpharma.com/account/login/internal?token=${this.getJti}`)
                this.redirected =true;
            }
        }
    },
    mounted(){
        this.redirectTo();
    }
}
</script>
